import React from 'react';

import RadioButtonGroup from '../../ui/components/radio-button-group';
import RadioButton from '../../ui/components/radio-button';
import withWindowResize from '../../ui/components/window-resize';
import Icon from '../../ui/components/icon';
import { withError } from '../../shared/components/error-boundary';
import SearchDrawer from '../../search-filter/components/search-drawer';
import VWAFilterCount from '../../vwa/components-v2/vwa-filter-count';
import FilterMenu from '../../filters';


class SaleMobileSort extends React.PureComponent {

    handleChange = (index) => {
        let { closeModal, options, setSort } = this.props;
        const { value } = options[index];
        closeModal();
        setSort(value);
    }

    render() {
        const { options, sortValue } = this.props;
        return (
            <RadioButtonGroup
                name={"slpmobilesort"}
                onChange={this.handleChange}
            >
                {
                    options.map((sort, index) => {
                        return (
                            <RadioButton
                                key={sort.label}
                                label={sort.label}
                                value={index}
                                checked={sort.value === sortValue}
                                data-metrics-event='e_facet'
                                data-metrics-event-name='sortBy'
                                data-metrics-sort-type={sort.label && sort.label.toLowerCase().replace(/\s/ig, '-')}
                            />);
                    })
                }
            </RadioButtonGroup>);
    }
}

function SaleFilters({ sortOptions, defaultExpandedFilters, setSort, sortValue, resultCount }) {
    return (
        <SearchDrawer label={'SORT & FILTER'} className={"slp-mobile-filters"} resultCount={resultCount}>
            {
                ({ closeDrawer }) => {
                    return (
                        <>
                            <div className={'header'}>
                                <Icon name={'x'} onClick={closeDrawer} />
                                <VWAFilterCount />
                            </div>
                            <SaleMobileSort sortValue={sortValue} options={sortOptions} closeModal={closeDrawer} setSort={setSort} />
                            <FilterMenu
                                useAlias={true}
                                defaultExpandedFilters={defaultExpandedFilters}
                                className='v2'
                                isV2={true} align={'right'} />
                        </>
                    );
                }
            }
        </SearchDrawer>);
}

export default withError(withWindowResize(React.memo(SaleFilters)));
